import { useSyncExternalStore } from 'react'
import { RoomStateItemX, TipMessage } from '../../../types/mfc'
import { pubSub } from '../../app-state/pubSub'
import { ROOMSSTATE } from '../../app-state/state'
import { getRoomsState } from '../../app-state/state.rooms'
import { RoomEvent } from '../../constants/enums'
import { isLounge } from '../../mfcLogic/userProperties/user'
import { useUserSelector } from './useUser'

const getRoomsRestored = () => ROOMSSTATE.restored
export const getPinnedRooms = () => ROOMSSTATE.pinnedRooms
export const getPinnedRoomCount = () => ROOMSSTATE.pinnedRooms.length
export const getIsRoomPinned = (id: number) => () =>
    !id ? false : ROOMSSTATE.pinnedRooms.includes(id)
export const getPinHelperID = () => ROOMSSTATE.pinHelperID
const getRoomTips = (id: number) => resolveRoomStateSelector(id, 'tips')
const resolveRoomStateSelector =
    <T extends keyof RoomStateItemX>(id: number, attribute: T) =>
    (): RoomStateItemX[T] => {
        const state = getRoomsState()[id] || { isLounge: isLounge(id), id }
        return state[attribute]
    }

const subPinnedRooms = (callback: () => void) =>
    pubSub.ROOM.on(RoomEvent.PIN_ROOM, callback)
const subPinHelperID = (callback: () => void) =>
    pubSub.ROOM.on(RoomEvent.PIN_HELPER_ID, callback)
const subRestored = (callback: () => void) =>
    pubSub.ROOM.on(RoomEvent.RESTORED, callback)
export const subRoom = (callback: () => void) =>
    pubSub.ROOM.on('state', callback)

export const useRoomRestored = () => {
    return useSyncExternalStore(subRestored, getRoomsRestored, getRoomsRestored)
}

export const usePinnedRooms = () => {
    const pinnedRooms = useSyncExternalStore(
        subPinnedRooms,
        getPinnedRooms,
        getPinnedRooms,
    )

    return pinnedRooms
}
export const useIsRoomPinned = (id: number) => {
    const isRoomPinned = useSyncExternalStore(
        subPinnedRooms,
        getIsRoomPinned(id),
        getIsRoomPinned(id),
    )

    return isRoomPinned
}
export const usePinnedRoomCount = () => {
    const pinnedRoomCount = useSyncExternalStore(
        subPinnedRooms,
        getPinnedRoomCount,
        getPinnedRoomCount,
    )

    return pinnedRoomCount
}
export const usePinHelperUser = () => {
    const pinHelperID = useSyncExternalStore(
        subPinHelperID,
        getPinHelperID,
        getPinHelperID,
    )
    const isFriend = useUserSelector(pinHelperID, 'isFriend')
    const isBookmark = useUserSelector(pinHelperID, 'isBookmark')
    return { id: pinHelperID, isFriend, isBookmark }
}

export const useRoomSelector = <T extends keyof RoomStateItemX>(
    id: number,
    attribute: T,
): RoomStateItemX[T] => {
    return useSyncExternalStore(
        subRoom,
        resolveRoomStateSelector(id, attribute),
        resolveRoomStateSelector(id, attribute),
    )
}

export const useRoomTips = (id: number): Array<TipMessage> => {
    return useSyncExternalStore(subRoom, getRoomTips(id), getRoomTips(id))
}
